import { GenericResponse } from 'services/api/base';
import { GetSeasonalComparatorOptionsResponse, SeasonalComparatorOptions } from 'types/Meteorology/Weather/SeasonalComparator/getSeasonalComparatorOptions';
import { RawSeasonalComparatorPreference, SeasonalComparatorPreference } from 'types/Meteorology/Weather/SeasonalComparator/listPreferences';
import { SeasonalComparatorImages, RawGetImagesResponse } from 'types/Meteorology/Weather/SeasonalComparator/getImages';

export const transformSeasonalComparatorGetOptionsResponse = (
  response: GetSeasonalComparatorOptionsResponse,
): SeasonalComparatorOptions => {
  const { data } = response;
  const uniqueVariables = data.map((option) => option.variavel_nome).filter(
    (value, index, self) => self.indexOf(value) === index,
  );
  return uniqueVariables.map((variable) => ({
    id: variable,
    label: data.find((option) => option.variavel_nome === variable)?.variavel.label || '',
    models: data.filter((option) => option.variavel_nome === variable).map((option) => ({
      id: option.modelos.id,
      label: option.modelos.label,
      center: option.modelos.centro,
      months: option.modelos.mensal,
      trimesters: option.modelos.trimestral,
      areas: option.areas,
    })),
  }));
};

export const transformSeasonalComparatorGetImages = (
  { data }: { data: RawGetImagesResponse },
): SeasonalComparatorImages => ({
  firstModelImage: data.modelo_confrontante,
  secondModelImage: data.modelo_base,
  differenceImage: data.diff,
});

export const transformSeasonalComparatorListPreferencesResponse = (
  response: GenericResponse<RawSeasonalComparatorPreference[]>,
): SeasonalComparatorPreference[] => (
  response.data.map((preference) => ({
    id: preference.id,
    userId: preference.user_id,
    name: preference.name,
    json: {
      variable: preference.json.variavel,
      area: preference.json.area,
      confrontingModel: {
        roundDate: preference.json.modelo_confrontante.data_rodada,
        model: preference.json.modelo_confrontante.modelo,
        initialDate: preference.json.modelo_confrontante.ano_mes_inicial,
        finalDate: preference.json.modelo_confrontante.ano_mes_final,
      },
      baseModel: {
        roundDate: preference.json.modelo_base.data_rodada,
        model: preference.json.modelo_base.modelo,
        initialDate: preference.json.modelo_base.ano_mes_inicial,
        finalDate: preference.json.modelo_base.ano_mes_final,
      },
    },
  }))
);
